import React, {useMemo} from "react";
import {HttpClient} from "./httpClient";
import {HttpClientContext, HttpClientContextType} from "./HttpClientContext";

export interface HttpClientProviderProps {
    client: HttpClient;
    children: React.ReactNode;
}

export function HttpClientProvider(props: HttpClientProviderProps): React.ReactElement {
    const {
        client,
        children
    } = props;
    const ContextValue = useMemo<HttpClientContextType>(() => {
        return {
            client: client,
        }
    }, [client])

    return <HttpClientContext.Provider value={ContextValue}>
        {children}
    </HttpClientContext.Provider>
}